const data = [
  {
    id: '1',
    title: 'Guess My Number',
    description:
      'Guess my number is an simpel and easy game in which you have to guess number between 1-100.(Its my 1st project)',
    image: {
      src: 'https://content.instructables.com/FKF/3M2G/K1NVASKL/FKF3M2GK1NVASKL.jpg?auto=webp&frame=1&fit=bounds&md=f603152d3711f5092071d170620548c6',
      placeholderSrc:
        'https://content.instructables.com/FKF/3M2G/K1NVASKL/FKF3M2GK1NVASKL.jpg?auto=webp&frame=1&fit=bounds&md=f603152d3711f5092071d170620548c6',
    },
    links: {
      site: 'https://guessmtrandomnumber.netlify.app/',
      repo: 'https://github.com/RajatPetkar/Guess-My-number',

    },
    technologies: [
      'html',
      'css',
      'javascript',
    ],
  },
  {
    id: '2',
    title: 'MERN - Weather',
    description:
    'MERN - Weather is Bacically My 1st Handlebar based website which can simply fetch Data from openWeather API.',
    image: {
      src: 'https://images.nationalgeographic.org/image/upload/t_edhub_resource_key_image/v1638886301/EducationHub/photos/lightning-bolts.jpg',
      placeholderSrc:
        'https://images.nationalgeographic.org/image/upload/t_edhub_resource_key_image/v1638886301/EducationHub/photos/lightning-bolts.jpg',
    },
    links: {
      site: 'https://responsive-weather.onrender.com/weather',
      repo : 'https://github.com/RajatPetkar/Responsive-Weather-Website---Node-Express'
    },
    technologies: [
      'js',
      'handlebar',
      'html',
      'css',
      'nodejs',
    ],
  },
  {
    id: '3',
    title: 'Apple Web Clone',
    description:
      'Apple Web is my first website that I bulid using pure BootStrap.',
    image: {
      src: 'https://cdsassets.apple.com/live/7WUAS350/images/apple-id/web-browser-appleid-apple-com-create-your-apple-id-callout.png',
      placeholderSrc:
        'https://cdsassets.apple.com/live/7WUAS350/images/apple-id/web-browser-appleid-apple-com-create-your-apple-id-callout.png',
    },
    links: {
      site: 'https://applewebsiteclonebyrajat.netlify.app/',
      repo: 'https://github.com/RajatPetkar/Apple-website-Clone',

    },
    technologies: [
      'html',
      'react',
      'js',
      'bootstrap',
      'css',
    ],
  },
  {
    id: '4',
    title: 'Chatting Website',
    description:
      'Simple and easy user interface for beginners. Works without login & signup',
    image: {
      src: 'https://www.epiqglobal.com/epiq/media/thinking/blog/chat-blog-angle.jpg?ext=.jpg',
      placeholderSrc:
        'https://www.epiqglobal.com/epiq/media/thinking/blog/chat-blog-angle.jpg?ext=.jpg',
    },
    links: {
      site: 'https://simple-chat-or1n.onrender.com/',
      repo: 'https://github.com/RajatPetkar/Simple-Chat-Web',

    },
    technologies: [
      'html',
      'react',
      'js',
      'bootstrap',
      'css',
    ],
  },
  {
    id: '5',
    title: 'Student Rest-API',
    description:
      'An Simple and easy API created using node-js, express-js & mangodb',
    image: {
      src: 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/what%20is%20an%20api167511875313774.jpg',
      placeholderSrc:
        'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/what%20is%20an%20api167511875313774.jpg',
    },
    links: {
      site: 'https://student-restful-api.onrender.com/students',
      repo: 'https://github.com/RajatPetkar/student-RESTFUL-API',

    },
    technologies: [
      'html',
      'node-js',
      'express-js',
      'mango-db',
    ],
  },
  {
    id: '6',
    title: 'Dice Game',
    description:
      'This is a simple web-based dice roll game built using HTML, CSS, and JavaScript. It allows players to roll virtual dice and compete against each other to achieve the highest score.',
    image: {
      src: 'https://www.spartanpoker.com/Media/Dice_Games_1200x400_1391476b85.jpg',
      placeholderSrc:
        'https://www.spartanpoker.com/Media/Dice_Games_1200x400_1391476b85.jpg',
    },
    links: {
      site: 'https://dicerollduel.netlify.app/',
      repo: 'https://github.com/RajatPetkar/Simple-Dice-Game-Dual-Player-',

    },
    technologies: [
      'html',
      'css',
      'js',
      'Bootstrap',
    ],
  },
  {
    id: '7',
    title: 'Mapty Project',
    description:
      'This is a fitness activity tracking application called Mapty, built using JavaScript and the Leaflet library. It allows users to log their workouts and view them on an interactive map.',
    image: {
      src: 'https://em360tech.com/sites/default/files/styles/cropper_main_image/public/2022-09/google%20maps%20new%20updates%20in%202022.png.webp?itok=3e_1Brua',
      placeholderSrc:
        'https://em360tech.com/sites/default/files/styles/cropper_main_image/public/2022-09/google%20maps%20new%20updates%20in%202022.png.webp?itok=3e_1Brua',
    },
    links: {
      site: 'https://mymaptyproject.netlify.app/',
      repo: 'https://github.com/RajatPetkar/Map-Using-JS',

    },
    technologies: [
      'html',
      'css',
      'js',
      'Bootstrap',
    ],
  },
];

export default data;
